export default __webpack_public_path__ + "static/media/Pickpocket's Wristbands of the Final way.b69359ae.jpg";